import React, { createContext, useState } from 'react';

// Create the context
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  // This state could hold user authentication data
  const [user, setUser] = useState(null);

  // A simple function to simulate login (to be replaced with real logic)
  const login = (userData) => {
    setUser(userData);
  };

  // A simple function to simulate logout
  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
